
import { Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent, DevExtremeModule } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { AppInformationService, CdrUnitOfWork, SessionInformationService, UtilityService } from 'src/app/core/core.module';
import { Job } from 'src/app/core/model/job';
import { JobTimeDialogComponent } from 'src/app/rentals/job-time-dialog/job-time-dialog.component';
import { DialogService } from 'src/app/shared/dialog.service';
import { InputDialogComponent } from 'src/app/shared/input-dialog/input-dialog.component';

@Component({
    selector: 'app-job-review',
    standalone: true,
    templateUrl: './job-review.component.html',
    styleUrls: ['./job-review.component.scss'],
    imports: [DevExtremeModule]
})
export class JobReviewComponent implements OnInit {
    jobs: any[];
    filter: any;
    minJobTime: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: CdrUnitOfWork,
        private appInfo: AppInformationService,
        private sessionInfo: SessionInformationService,
        private dialogService: DialogService,
        private utilityService: UtilityService
    ) {}

    async ngOnInit() {
        this.filter = this.sessionInfo.getItem('job-review-min-time', true);
        if (!this.filter) this.filter = 60;
        this.minJobTime = this.filter;
        await this.getData();
    }

    async getData() {
        this.jobs = await this.uow.jobs.getReviewJobs(this.filter, 'rental.customer, jobTimes, action');
        this.jobs.forEach(x => {
            x._totalTime = x.calcTotalTime();
        });
    }

    rowDoubleClick(e) {
        this.openJobTimes(e.data.id);
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        this.sessionInfo.setItem('job-review-min-time', this.filter, true);
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons'
            },
            {
                template: 'toolbarText',
                location: 'after'
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    }
                }
            },
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    }
                }
            }
        );
    }

    async openJobTimes(id: number) {
        const dialogRef = this.dialogService.open(JobTimeDialogComponent);
        dialogRef.instance.jobId = id;
        const results = await dialogRef.instance.show();
        this.dialogService.close(dialogRef);
        await this.getData();
    }

    async setJobTimes(selectedRows: any[]) {
        if (!selectedRows) return;

        const dialogRef = this.dialogService.open(InputDialogComponent);
        dialogRef.instance.dialogHeader = 'Enter Time';
        dialogRef.instance.mode = 'text';
        dialogRef.instance.dialogWidth = 400;
        dialogRef.instance.checkNumeric = true;
        dialogRef.instance.dialogValue = this.filter;
        const result = await dialogRef.instance.show();
        if (result.success && result.value) {
            const check = await confirm(
                `Are you sure you want to set times for ${selectedRows.length} jobs to ${result.value}?`,
                `${this.appInfo.company}`
            );
            if (!check) {
                return;
            }

            this.appInfo.pleaseWaitShow();
            await this.utilityService.setJobTimeLengths(
                selectedRows.map(x => x.id),
                result.value
            );
            await this.getData();
            this.appInfo.pleaseWaitHide();
        }
    }
}
